const BlockList: React.FC<{ children: string[] }> = ({ children }) => (
  <ul className="flex-col stack-8">
    {children.map((item, index) => (
      <li key={index} className="bg-secondary p-16 md:px-24">
        <p className="text-secondary" style={{ wordBreak: 'break-all' }}>
          {item}
        </p>
      </li>
    ))}
  </ul>
);

export default BlockList;
